import { ISSUE_DETAILS_ACTION, STATUS } from "../constant";

const initState = {
  issueData: null,
  commentData: [],
  issueAgeingReport: [],
  upcomingMeetings: [],
  meetingListData: {},
  meetingStatus: null,
  history: []
};

export default function issueDetails(state = initState, action) {
  switch (action.type) {
    case ISSUE_DETAILS_ACTION.ISSUE_DETAILS_START:
      return { ...state, issueDetailsStatus: STATUS.LOADING };
    case ISSUE_DETAILS_ACTION.ISSUE_DETAILS_SUCCESS: {
      return {
        ...state,
        issueData: action.payload,
        issueDetailsStatus: STATUS.SUCCESS
      };
    }
    case ISSUE_DETAILS_ACTION.CLEAR_ISSUE_DETAILS:
      return { ...state, issueDetails: null };

    case ISSUE_DETAILS_ACTION.ISSUE_DETAILS_FAILURE:
      return { ...state, issueDetailsStatus: STATUS.ERROR };

    case ISSUE_DETAILS_ACTION.SUBMIT_COMMENT_START:
      return { ...state, commentStatus: STATUS.LOADING };
    case ISSUE_DETAILS_ACTION.SUBMIT_COMMENT_SUCCESS: {
      return {
        ...state,
        commentData: action.payload,
        commentStatus: STATUS.SUCCESS
      };
    }
    case ISSUE_DETAILS_ACTION.SUBMIT_COMMENT_FAILURE:
      return { ...state, commentStatus: STATUS.ERROR };

    case ISSUE_DETAILS_ACTION.ISSUE_AGEING_REPORT_START:
      return { ...state, ageingStatus: STATUS.LOADING };
    case ISSUE_DETAILS_ACTION.ISSUE_AGEING_REPORT_SUCCESS: {
      return {
        ...state,
        issueAgeingReport: action.payload,
        ageingStatus: STATUS.SUCCESS
      };
    }
    case ISSUE_DETAILS_ACTION.ISSUE_AGEING_REPORT_FAILURE:
      return { ...state, ageingStatus: STATUS.ERROR };

    case ISSUE_DETAILS_ACTION.UPCOMING_MEETINGS_START:
      return { ...state, upcomingMeetingsStatus: STATUS.LOADING };
    case ISSUE_DETAILS_ACTION.UPCOMING_MEETINGS_SUCCESS: {
      return {
        ...state,
        upcomingMeetings: action.payload,
        upcomingMeetingsStatus: STATUS.SUCCESS
      };
    }
    case ISSUE_DETAILS_ACTION.UPCOMING_MEETINGS_FAILURE:
      return { ...state, upcomingMeetingsStatus: STATUS.ERROR };

    case ISSUE_DETAILS_ACTION.ISSUE_ACTIVITY_HISTORY_START:
      return { ...state, historyStatus: STATUS.LOADING };

    case ISSUE_DETAILS_ACTION.ISSUE_ACTIVITY_HISTORY_SUCCESS:
      return {
        ...state,
        history: action.payload,
        historyStatus: STATUS.SUCCESS
      };

    case ISSUE_DETAILS_ACTION.ISSUE_ACTIVITY_HISTORY_FAILURE:
      return { ...state, historyStatus: STATUS.ERROR };

    case ISSUE_DETAILS_ACTION.ISSUE_MEETING_SUCCESS:
      return {
        ...state,
        meetingStatus: STATUS.SUCCESS,
        meetingListData: action.payload
      };

    case ISSUE_DETAILS_ACTION.ISSUE_MEETING_FAILURE:
      return { ...state, meetingStatus: STATUS.ERROR };

    case ISSUE_DETAILS_ACTION.ISSUE_MEETING_START:
      return { ...state, meetingStatus: STATUS.LOADING };

    case ISSUE_DETAILS_ACTION.ISSUE_COMMENT_SUCCESS:
      return {
        ...state,
        commentStatus: STATUS.SUCCESS,
        commentListData: action.payload
      };

    case ISSUE_DETAILS_ACTION.ISSUE_COMMENT_FAILURE:
      return { ...state, commentStatus: STATUS.ERROR };

    case ISSUE_DETAILS_ACTION.ISSUE_COMMENT_START:
      return { ...state, commentStatus: STATUS.LOADING };

    default:
      return state;
  }
}
